import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-report-list',
  templateUrl: './partner-report-list.component.html',
  styleUrls: ['./partner-report-list.component.css']
})
export class PartnerReportListComponent implements OnInit {

  menuList: any;
  allowedComponents = new Set<string>();

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
      menu.menu?.menuComponents?.forEach(component => {
        this.allowedComponents.add(component.name);
      });
    });
  }

  hasAccess(componentName: string): boolean {
    return this.allowedComponents.has(componentName);
  }

  budgetClick(){
    this.router.navigate(['dashboard/budget-report']);
  }
  overtimeReportClick(){
    this.router.navigate(['dashboard/overtime-report']);
  }
  independenceDeclarationClick(){
    this.router.navigate(['dashboard/all-independence-declaration']);
  }
  varianceReportClick(){
    this.router.navigate(['dashboard/budget-vs-actual-cost']);
  }
  varianceReportSummaryClick(){
    this.router.navigate(['dashboard/variance-report-excel']);
  }
  articleDebitCreditReportClick(){
    this.router.navigate(['dashboard/article-debit-credit-hours']);
  }
  actualTaskSummaryReportClick(){
    this.router.navigate(['dashboard/actual-task-report']);
  }
  manageAnnouncementClick(){
    this.router.navigate(['dashboard/manage-announcement-history']);
  }
  diaryReportClientWiseClick(){
    this.router.navigate(['dashboard/diary-details-client-wise']);
  }
  misReportClick(){
    this.router.navigate(['dashboard/mis-report']);
  }
}
